module.exports = __webpack_public_path__ + "img/icon-pencil.20713cf0.svg";